import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "src/config/apiBase";
import { PenLine } from "lucide-react";
import "./LeadsUpdatedVersion.css";

const CrmSignPage = () => {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [name, setName] = useState("");
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const url = API_BASE_URL;

  useEffect(() => {
    if (!token) return;
    fetch(`${url}/leads/sign/${token}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((res) => {
        setData(res);
        if (res?.signerName) setName(res.signerName);
        if (res?.status === "signed") setDone(true);
      })
      .catch(() => setData(null));
  }, [token, url]);

  const sign = async () => {
    setSubmitting(true);
    try {
      const res = await fetch(`${url}/leads/sign/${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ signerName: name }),
      });
      if (res.ok) setDone(true);
    } finally {
      setSubmitting(false);
    }
  };

  if (!data) {
    return (
      <div className="crm-sign-page">
        <p>Loading…</p>
      </div>
    );
  }

  return (
    <div className="crm-sign-page">
      <div className="crm-sign-page__card">
        <PenLine size={32} />
        <h1>{data.title || "Sign document"}</h1>
        <p>For: {data.leadName}</p>
        {data.amount != null && <p className="crm-sign-page__amount">Amount: ₹{Number(data.amount).toLocaleString("en-IN")}</p>}

        {done ? (
          <p className="crm-sign-page__done">Thank you — your signature has been recorded.</p>
        ) : (
          <>
            <label>
              Your full name
              <input value={name} onChange={(e) => setName(e.target.value)} />
            </label>
            <button type="button" onClick={sign} disabled={!name.trim() || submitting}>
              {submitting ? "Signing…" : "I agree & sign"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default CrmSignPage;
